import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Tip.module.scss';

const Tip = ({ title, type, iconClassName, small, className, children, inline }) => {
  const icon = iconClassName || (type === 'warning' ? 'las la-exclamation-triangle' : 'la la-info-circle');
  return (
    <div className={cn(styles.tip, styles[type], { [styles.small]: small, [styles.inline]: inline }, className)}>
      {iconClassName !== 'none' && (
        <i className={cn(icon, styles.icon)} />
      )}
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {_.isString(children) ? <p>{children}</p> : children}
      </div>
    </div>
  );
};

Tip.propTypes = {
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'transparent']),
  iconClassName: PropTypes.string,
  small: PropTypes.bool,
  className: PropTypes.string,
  inline: PropTypes.bool,
  title: PropTypes.node,
};

Tip.defaultProps = {
  type: 'info',
  iconClassName: null,
  small: false,
  className: null,
  inline: false,
  title: null,
};

export default Tip;
